export const MARKETING_AGREEMENT_ACCEPTED = '1';
export const MARKETING_AGREEMENT_NOT_ACCEPTED = '0';
